import { Component, Input, OnInit } from '@angular/core';
import { FrequencyProvider } from "../../shared/providers/frequency.provider";
import { RolesProvider } from "../../shared/providers/roles.provider";
import { ChannelProvider } from "../../shared/providers/channel.provider";
import { RegionProvider } from "../../shared/providers/region.provider";
import { StateProvider } from '../../shared/providers/state.provider';
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateFormateService } from "../../../services/date-formate.service";
import { state } from '@angular/animations';
// import { status } from 'src/app/redemption/physical-reward/orders-static-data';

@Component({
  selector: 'app-scheme-configuration',
  templateUrl: './scheme-configuration.component.html',
  styleUrls: ['./scheme-configuration.component.scss']
})

export class SchemeConfigurationComponent implements OnInit {
  selectedScheme: String = '1';
  selectedBasedOn: String = '1';
  selectedAllocationType: String = '1';
  selectedRewardType: String = '1';
  selectedMetricesType: String;
  growthAndPortfolioArray: any = [{}];
  rewardData: any = {};
  filterParams;
  filteredDetails: any = { regions: [], outlets: [], states:[] };
  users: any = [];
  schemeConfigSettings: any = {}

  selectedUsers: any = [];
  selectAll: Boolean = true;
  finalUserList: any = [];
  term;

  formData: any = {
    scheme_name: '',
    program_id: 1,
    campaign_id: 2,
    user_type: 5,
    tier: "",
    regions: "",
    states:"",
    channel_type: 5,
    scheme_type: "",
    based_on: "",
    reward_data: "",
    all_users:1
  }

  detailsFormData: any = {
    s_no: 1,
    basedOn: '',
    sku_name: '',
    categoryName: '',
    condition_value: '',
    condition_unit: '',
    metric: '',
    growth_value: '',
    growth_unit: '',
    scheme_point: '',
    points: "",
  };

  t1Array: any = [this.detailsFormData];
  t2Array: any = [this.detailsFormData];

  schemeTypes = [
    {
      id: 1,
      name: 'Value'
    },
    {
      id: 2,
      name: 'Volume'
    },
    {
      id: 15,
      name: 'QR Based'
    },


    // {
    //   id: 3,
    //   name: 'Focus SKU'
    // },
    // {
    //   id: 4,
    //   name: 'Growth%'
    // },
    // {
    //   id: 5,
    //   name: 'Portfolio'
    // }
  ]

  basedOnTypes = [
    {
      id: 1,
      name: 'SKU'
    },
    {
      id: 2,
      name: 'Category'
    }
  ]

  tier = [
    {
      id: 1,
      name: 'Silver'
    },
    {
      id: 2,
      name: 'Gold'
    }
  ]

  pointsAllocationTypes = [
    {
      id: 1,
      name: 'Individual'
    },
    // {
    //   id: 2,
    //   name: 'Combined'
    // }
  ]

  rewardTypes = [
    {
      id: 1,
      name: 'Percentage'
    },
    {
      id: 2,
      name: 'Points'
    },
    {
      id: 3,
      name: 'Fixed Points'
    },
    {
      id: 16,
      name: 'Referral'
    },
  ]
  rewardTypesQR = [
    {
      id: 1,
      name: 'Percentage'
    },

    {
      id: 3,
      name: 'Fixed Points'
    },
    {
      id: 16,
      name: 'Referral'
    },
  ];
  ;
  

  metricesTypes = [
    {
      id: 1,
      name: 'Value'
    },
    {
      id: 2,
      name: 'Volume'
    }
  ]

  productList: any = [];

  categoryList: any = [];

  roles: any = [];
  channels: any = [];
  regions: any = [];
  states: any=[];
  fequencyList: any = [];
  id: any;
  schemeApplicability: any;
  constructor(
    public frequencyProvider: FrequencyProvider,
    public rolesProvider: RolesProvider,
    public channelProvider: ChannelProvider,
    public regionProvider: RegionProvider,
    public stateProvider:StateProvider,
    public adminDataProvider: AdminDataProvider,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private formateDate: DateFormateService
  ) {
  }

  ngOnInit() {
    this.getProductList();
    // this.getProductCategories();
    // this.getSchemeConfigSettings();

    //initial parameters
    this.formData.scheme_type = this.selectedScheme;
    this.formData.based_on = this.selectedBasedOn;
    this.rewardData.reward_type = '1';
    this.rewardData.points_allocation = '1';
    this.rewardData.if_value = 'All';
    this.rewardData.condition_value = 'True'
  }

  ngDoCheck() {
    this.fequencyList = this.frequencyProvider.frequency;
    this.roles = this.rolesProvider.roles;
    this.channels = this.channelProvider.channels;
    this.regions = this.regionProvider.regions;
    this.states=this.stateProvider.state;
  }

  getSchemeConfigSettings() {
    this.apiService.get(this.apiConfig.getSchemeConfigSettings)
      .subscribe((res: any) => {
        this.schemeConfigSettings = res.data
      }, err => {

      });
  }

  addNewInput() {

    if (this.selectedBasedOn == '1') {
      if (this.productList.length <= this.t1Array.length) {
        this.toast.Error("Limit Reached !!")
      } else {
        this.t1Array.push(JSON.parse(JSON.stringify(this.detailsFormData)));
        //
        var changeSlNo = this.t1Array.length;
        this.t1Array[changeSlNo - 1].s_no = changeSlNo;
      }
    } else if (this.selectedBasedOn == '2') {
      if (this.categoryList.length <= this.t1Array.length) {
        this.toast.Error("Limit Reached !!")
      } else {
        this.t1Array.push(JSON.parse(JSON.stringify(this.detailsFormData)));
        //
        var changeSlNo = this.t1Array.length;
        this.t1Array[changeSlNo - 1].s_no = changeSlNo;
      }
    }

  }

  removeInput(table, i) {
    if (table == 't1') {
      if (this.t1Array.length > 0) {
        this.t1Array.splice(i, 1)
      }
    }
    if (table == 't2') {
      if (this.growthAndPortfolioArray.length > 0) {
        this.growthAndPortfolioArray.splice(i, 1)
        this.t2Array.splice(i, 1)
      }
    }
  }

  getProductList() {
    this.apiService.get(this.apiConfig.getSchemeProductCategory)
      .subscribe((res: any) => {
        this.productList = res.data.product_details;
        this.categoryList = res.data.ecommerce_categories;
      }, err => {
        this.toast.Error('Error getting products');
      })
  }



  roleSelected(role) {
    this.formData.user_type = role;
  }

  tierSelected(t) {
    this.formData.tier = t;
  }

  channelSelected(channel) {
    this.formData.channel_type = channel;
  }

  schemeSelected(scheme) {
    this.selectedScheme = scheme;
    this.t1Array.splice(1);
    if (this.selectedScheme == '4' || this.selectedScheme == '5') {
      this.selectedBasedOn = '';
    }
  }

  basedOnSelected(basedOn) {
    this.selectedBasedOn = basedOn;
  }

  allocationTypeSelected(allocation) {
    this.selectedAllocationType = allocation;
  }

  schemeApplicabilitySelected(schemeapplicability)
  {
    this.formData.all_users=schemeapplicability;
  }

  rewardTypeSelected(reward) {
    this.selectedRewardType = reward;
  }

  basedOnMetrices(metrices, i) {
    this.selectedMetricesType = metrices;
    this.t1Array[i].metric = metrices;
  }

  //Table 1 selected values
  t1ProductSelected(value, i) {
    this.t1Array[i].sku_name = value;

    // this.productList.forEach((element: any, index: any) => {
    //   if (index == i) {
    //     this.productList.splice(index, 1);
    //   }
    // });

  }

  t1CategorySelected(value, i) {
    this.t1Array[i].categoryName = value;
  }

  t1ConditionValue(value, i) {
    this.t1Array[i].condition_value = value;
  }

  t1PointsPerUnit(value, i) {
    this.t1Array[i].scheme_point = value;
  }

  t1ConditionUnit(value, i) {
    this.t1Array[i].condition_unit = value;
  }

  t1Points(value, i) {
    this.t1Array[i].points = value;
  }

  //TABLE 2, i.e growth% and Portfolio

  t2AddNewInput() {
    this.growthAndPortfolioArray.push({});
    this.t2Array.push(JSON.parse(JSON.stringify(this.detailsFormData)));
    var changeSlNo = this.t2Array.length;
    this.t2Array[changeSlNo - 1].s_no = changeSlNo;
  }

  t2ProductSelected(value, i) {
    this.t2Array[i].sku_name = value;
  }

  t2CategorySelected(value, i) {
    this.t2Array[i].categoryName = value;
  }

  t2BasedOnSelected(value, i) {
    this.growthAndPortfolioArray[i].name = value;
    this.t2Array[i].basedOn = value;
  }

  t2ConditionValue(value, i) {
    this.t2Array[i].condition_value = value;
  }

  t2ConditionUnit(value, i) {
    this.t2Array[i].condition_unit = value;
  }

  t2MetricesSelected(value, i) {
    this.growthAndPortfolioArray[i].metrices = value;
    this.t2Array[i].metric = value;
  }

  t2Points(value, i) {
    this.t2Array[i].points = value;
  }

  t2GrowthValue(value, i) {
    this.t2Array[i].growth_value = value;
  }

  t2PointsPerUnit(value, i) {
    this.t2Array[i].scheme_point = value;
  }

  t2GrowthUnit(value, i) {
    this.t2Array[i].growth_unit = value;
  }

  /** User Assignment section */
  /* Fillter section start */

  formateFillters(data, name) {
    console.log(data)
    switch (name){
      case 'regions':
        this.filteredDetails[name] = data.map(item =>item.id);
      case 'states':
        this.filteredDetails[name] = data.map(item =>item.id);
      }
    console.log(this.filteredDetails)

    // this.filteredDetails[name].push(data.id)
    // console.log("sdfdsfdsfsd",data,this.filteredDetails[name])
    if (data.status == "singleSelect") {
      this.filteredDetails[name].push(data.id);
      console.log(this.filteredDetails[name])
      return this.filteredDetails[name];
    } else if (data.status == "singleDeselect") {
      this.filteredDetails[name].forEach((element, i) => {
        if (element == data.data.id) {
          this.filteredDetails[name].splice(i, 1)
        }
      });
      return this.filteredDetails[name];
    } else if (data.status == "SelectAll") {
      this.filteredDetails[name] = [];
      if (data.data) {
        data.data.forEach(element => {
          this.filteredDetails[name].push(element.id);
        });
      }
      return this.filteredDetails[name];
    } else if (data.status == "unSelectAll") {
      this.filteredDetails[name] = [];
      return this.filteredDetails[name];
    }
  }



  checkRequiredFieldsAndSubmit() {
    //this.getSelectedUsers();
    this.formData.scheme_type = this.selectedScheme;
    this.formData.based_on = this.selectedBasedOn;
    //this.formData.outlets = this.users
    this.formData.regions = this.filteredDetails.regions
    this.formData.states=this.filteredDetails.states


    // if (this.filteredDetails.outlets.length == 0) {
    //   this.toast.Error('Select Outlets');
    //   return
    // } else {
    //   this.formData.outlets = this.filteredDetails.outlets
    //   this.formData.regions = this.filteredDetails.regions
    // }



    if (this.formData.scheme_name.includes("<") || this.formData.scheme_name.includes(">")) {
      this.toast.Error('Special characters not allowed!');
      return
    } else {

    }


    if (this.formData.scheme_type == '1' || this.formData.scheme_type == '2' || this.formData.scheme_type == '3') {
      this.t1Array.forEach((t1, i) => {
        //
        if (t1.condition_value == '') {
          this.toast.Error(`Missing Values in for condition ${t1.s_no}.`)
          return
        }
      });
    }

    if (this.formData.scheme_type == '4' || this.formData.scheme_type == '5') {
      this.t2Array.forEach((t2, i) => {
        //
        if (t2.basedOn == '' || t2.metric == '') {
          this.toast.Error(`Missing Values in for condition ${t2.s_no}.`)
          return
        }
      });
    }

    if (this.formData.scheme_name == undefined || this.rewardData.scheme_detail_desc == undefined || this.rewardData.scheme_detail_name == undefined || this.rewardData.scheme_detail_eligibility == undefined || this.rewardData.scheme_detail_tnc == undefined) {
      this.toast.Error("Fill All Scheme detail fields")
      return
    }

    this.onSubmitConfigurations()

  }

  onSubmitConfigurations() {

    if (this.formData.scheme_type == '1' || this.formData.scheme_type == '2' || this.formData.scheme_type == '3') {
      this.rewardData.sku_details = this.t1Array;
    } else {
      this.rewardData.sku_details = this.t2Array;
    }
    this.formData

    this.rewardData.reward_type = this.selectedRewardType;
    this.rewardData.points_allocation = this.selectedAllocationType;
    this.formData.reward_data = this.rewardData
    this.rewardData.period_start = this.formData.from
    this.rewardData.period_end = this.formData.to
    // 
    // return
    this.apiService.post(this.apiConfig.saveScheme, this.formData)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.toast.Success(res.body.data);
          this.router.navigateByUrl('/hubAdmin/schemes-list');
          // this.router.navigateByUrl("/hubAdmin/Whitelistusers" + res.body.data.scheme_id);   
          // Above need scheme id also in response
        } else if (res.status == 201) {
          
          this.toast.Error(res.body.data.message);
        }

      },(err)=>{
        this.toast.Error(err)
      })
  }

}
